import React, {Fragment} from 'react';
import {ICorrectionWayPointSingleVoyage} from "@containers/singleVoyage/types/point";
import {
    onDragEndMarkerCorrectionPointsSingleVoyage,
    onRemoveMarkerCorrectionPointsSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/types/events";
import MarkerItemDraggableCorrectionPointsSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/changeCorrectionPoints/MarkerItemDraggableCorrectionPointsSingleVoyage";

interface IProps {
    points: ICorrectionWayPointSingleVoyage[]
    onDragEndMarker: onDragEndMarkerCorrectionPointsSingleVoyage,
    onRemoveMarker: onRemoveMarkerCorrectionPointsSingleVoyage,
}


const MarkersDraggableCorrectionPointsSingleVoyage = ({
                                                          points,
                                                          onDragEndMarker,
                                                          onRemoveMarker,
                                                      }: IProps) => {

    const list = points?.map((point, index, array) => {
        if (index === 0 || index === array.length - 1) {
            return (
                <Fragment
                    key={point.id}
                />
            )
        }
        return (
            <MarkerItemDraggableCorrectionPointsSingleVoyage
                onDragEndMarker={onDragEndMarker}
                onRemoveMarker={onRemoveMarker}
                key={point.id}
                point={point}
                index={index}
            />
        )
    })

    return (
        list
    );
};

export default MarkersDraggableCorrectionPointsSingleVoyage;